import React, { useState, useEffect, useRef, useCallback } from "react";
import ConvertTimeFormat from "../format/ConvertTime";
import "./StopWatch.scss";
import { formatTimeelapsedTime, formatTimes } from "../format/FormatTime";
import { regex } from "../../constants/Regex";

const Stopwatch = ({ Time, check, Clear, backStart }) => {
  const [time, setTime] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [inputTime, setInputTime] = useState("");
  const [elapsedTime, setElapsedTime] = useState(0);
  const [action, setAction] = useState(false);
  const [error, setError] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (isActive) {
      intervalRef.current = setInterval(() => {
        const currentTime = Date.now();
        const elapsed = Math.floor((currentTime - time) / 1000);
        setElapsedTime(elapsed);
      }, 1000); // Update every second
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, [isActive, time]);

  const handleStartStop = () => {
    if (!isActive) {
      setIsActive(true);
      setTime(Date.now() - elapsedTime * 1000);
      setAction(true);
      backStart(false);
    } else {
      setIsActive(false);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }
  };

  const handleReset = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    setTime(0);
    setIsActive(false);
    setInputTime("");
    setElapsedTime(0);
  }, []);

  const handleInputTime = (event) => {
    const inputValue = event.target.value.trim();
    setInputTime(inputValue);
  };
  useEffect(() => {
    if (inputTime !== "" && !regex.test(inputTime)) {
      setError(true);
    } else {
      setError(false);
    }
  }, [inputTime]);

  const handleCurrentTime = () => {
    setIsActive(false);
  };

  useEffect(() => {
    if (check === true) {
      handleCurrentTime();
    }
    if (action === true) {
      backStart(false);
    }
  }, [check, action, backStart]);

  useEffect(() => {
    if (Clear === true) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      setTime(0);
      setInputTime("");
      handleReset();
    }
  }, [Clear, handleReset]);

  useEffect(() => {
    if (inputTime !== "") {
      const newTimeDifference = ConvertTimeFormat(inputTime);
      if (Time) {
        Time(newTimeDifference);
      }
    } else {
      setInputTime("");
      if (formatTimes(elapsedTime) !== "00:00") {
        Time(formatTimes(elapsedTime));
      } else {
        Time("0:0");
      }
    }
  }, [inputTime, Time, elapsedTime]);

  return (
    <div className="stopwatch">
      <div className="frame-button-start-reset">
        <button className="button-app" onClick={handleStartStop}>
          {isActive ? "Tạm Dừng" : "Bắt Đầu"}
        </button>
        <button className="button-app-remove" onClick={handleReset}>
          Xóa T.Gian
        </button>
      </div>
      <div className="countime">
        <span>Thời Gian :</span>

        <div className="frame-input-time-error">
          <input
            type="text"
            value={inputTime}
            onChange={handleInputTime}
            className={error ? "error" : "inputTime"}
          />
          <div>{error && <span className="errror-text">Nhập Sai</span>}</div>
        </div>

        <div className="frame-elapsedTime">
          <span>
            {inputTime !== "" ? "0:0:0" : formatTimeelapsedTime(elapsedTime)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Stopwatch;
